/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetTransactionsSettlementsOptions,
  GetTransactionsSettlementsResponses,
} from '../types/GetTransactionsSettlements'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Get transactions settlements with filters
 * {@link /v1/transactions/settlements}
 */
export function getTransactionsSettlements<ThrowOnError extends boolean = true>(
  options: Options<GetTransactionsSettlementsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetTransactionsSettlementsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/transactions/settlements',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetTransactionsSettlementsResponses, ThrowOnError>>,
  )
}
